import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        rootglobal: {
            pagetitle: '壹选生活',
        },
        LOADING: false,
        isShowFun: false,
        recruitScrollY:0 
    },
    mutations: {
        settitle(state, title) {
            state.rootglobal.pagetitle = title;
        },
        showLoading(state) {
            state.LOADING = true
        },
        hideLoading(state) {
            state.LOADING = false
        },
        showFun(state) {
            state.isShowFun = true
        },
        hideFun(state) {
            state.isShowFun = false
        },
        changeRecruitScrollY(state,recruitScrollY) { 
        state.recruitScrollY = recruitScrollY 
        } 
    },
    actions: {}, 
    getters: { 
        recruitScrollY:state => state.recruitScrollY 
    }, 
    modules: {} 


})



// WEBPACK FOOTER //
// ./src/js/store.js